//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let mainTitleFontSize = '5rem';
	let outerStyleHeight = `100vh`;
	let titleRowMarginTop = `auto`;
	let rightColPaddingLeft = `2rem`;
	//#endregion

	//#region seting vars based off params
	if (isMobile) {
		mainTitleFontSize = '4rem';
		outerStyleHeight = `auto`;
		titleRowMarginTop = `1rem`;
		rightColPaddingLeft = `0rem`;
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				padding: `0rem ${minimumMarginX}rem 1rem ${minimumMarginX}rem`,
				height: outerStyleHeight,
			};
		},
		titleRow: () => {
			return {
				display: 'flex',
				marginTop: titleRowMarginTop,
			};
		},
		mainTitleStyle: () => {
			return {
				color: 'black',
				margin: `auto`,
				textAlign: 'center',
				fontSize: mainTitleFontSize,
			};
		},
		mainContentRow: () => {
			return {
				display: 'flex',
				width: `100%`,
				flexWrap: `wrap`,
				boxSizing: `border-box`,
				marginBottom: 'auto',
				maxWidth: '100%',
				maxHeight: '100%',
				overflow: 'hidden',
			};
		},
		imageStyle: ({BG} = {}) => {
			return {
				height: 'auto',
				maxHeight: '100%',
				maxWidth: '100%',
				marginTop: '1rem',
				borderRadius: `10px`,
				objectFit: 'cover',
				backgroundImage: `url(${BG})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
			};
		},
		imageClasses: () => {
			let classes = 'col-12 col-sm-6';
			return classes;
		},
		rightColClasses: () => {
			let classes = 'col-12 col-sm-6 my-sm-5';
			return classes;
		},
		rightColStyle: () => {
			return {
				maxWidth: '100%',
				paddingLeft: rightColPaddingLeft,
				display: 'flex',
			};
		},
		YGAPText: ({removeLargeTopMargin, larger} = {}) => {
			let style = {
				marginTop: `1rem`,
			};
			if (size === 'xl' && larger) {
				style.fontSize = '2rem';
			}
			if (!isMobile) {
				if (removeLargeTopMargin) {
					style.marginTop = `0rem`;
				}
			}
			return style;
		},
		textCenterer: () => {
			let style = {
				width: '100%',
				height: 'auto',
				margin: 'auto',
			};
			return style;
		},
	};
}

export default Styles;
